import Axios from "../axios";
import { ApiResponse } from "../apiResponse";
import UserModel from "../models/UserModel";

export function login(email: string, password: string): Promise<any> {
  return Axios.post("/v1/auth/sign_in", {
    email: email,
    password: password,
  });
}
export function forgotPassword(email: string): Promise<any> {
  return Axios.post("/v1/auth/password", {
    email: email,
    redirect_url: "https://google.com",
  });
}
export function resetPassword(password: string, token: string): Promise<any> {
  return Axios.put("/v1/auth/password", {
    reset_password_token: token,
    password: password,
    password_confirmation: password,
  });
}
export function getCurrentUserInfo() {
  return Axios.get("v1/accounts/current");
}
